/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"],
  _excluded7 = ["children"],
  _excluded8 = ["children"];
import "./styled-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

// TODO: remove this override behaviour for @atlaskit/icon-object
var iconObjectOverrideStyles = null;

// TODO: remove this override behaviour for @atlaskit/icon
var iconOverrideStyles = null;
var iconWrapperStyles = null;

// Wraps all icons represented in Inline Links. Icons have three sources/types:
// - JSON-LD: from the generator.icon property coming back from ORS.
// - @atlaskit/icon: for lock icons, unauthorized, etc.
// - @atlaskit/icon-object: for object icons, e.g. repository, branch, etc.
// NB: the first set of overrides style icons imported from @atlaskit/icon-object correctly.
// NB: the second set of overrides style icons imported from @atlaskit/icon correctly.
export var IconWrapper = function IconWrapper(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_uiztglyw", "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe", "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"])
  }), children);
};
var emojiWrapperStyles = null;

// Wraps all emoji in Inline Links similar to icon
export var EmojiWrapper = function EmojiWrapper(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_1e0c1o8l _2hwxv77o _uiztglyw", "_1f027vkz _nbgxdlk8 _4d7tstnw _o5fvidpf _3g5ridpf _z6uadlk8 _1fqgstnw _d1gw1ssb _1gx11ssb _18lx1ooe", "_17047vkz _iibfdlk8 _lacastnw _1kd9idpf _1yg7idpf _15x0stnw _k9fw1ssb _1tr81ssb _q3v31ooe"])
  }), children);
};
var iconTitleWrapperStyles = null;

// The main 'wrapping' element, title of the content.
// NB: `white-space` adds little whitespace before wrapping.
// NB: `word-break` line breaks as soon as an overflow takes place.
export var IconTitleWrapper = function IconTitleWrapper(_ref3) {
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_o5721jtm _1nmz9jpi"])
  }), children);
};
var lozengeWrapperStyles = null;

// TODO: Replace overrides with proper AtlasKit solution.
export var LozengeWrapper = function LozengeWrapper(_ref4) {
  var children = _ref4.children,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_1e0c1o8l _s7n4t94y _1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"])
  }), children);
};
var lozengeBlockWrapperStyles = null;

// TODO: Replace overrides with proper AtlasKit solution.
export var LozengeBlockWrapper = function LozengeBlockWrapper(_ref5) {
  var children = _ref5.children,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_1msp1b66 _1at8v77o _hjaqidpf _1cjov77o _1yg6idpf"])
  }), children);
};
var rightIconPositionWrapperStyles = null;
export var RightIconPositionWrapper = function RightIconPositionWrapper(_ref6) {
  var children = _ref6.children,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_18u0v77o _2hwx1b66 _kqswh2mm _1e0c1o8l"])
  }), children);
};
var iconPositionWrapperStyles = null;

// The following components are used to absolutely position icons in the vertical center.
// - IconPositionWrapper: the `relative` parent which has no height in itself.
// - IconEmptyWrapper: the child which forces `IconPositionWrapper` to have a height.
export var IconPositionWrapper = function IconPositionWrapper(_ref7) {
  var children = _ref7.children,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_2hwx1b66 _kqswh2mm _1e0c1o8l"])
  }), children);
};
var iconEmptyWrapperStyles = null;
export var IconEmptyWrapper = function IconEmptyWrapper(_ref8) {
  var children = _ref8.children,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/React.createElement("span", _extends({}, props, {
    className: ax(["_1bsbdlk8 _4t3i1osq _1e0c1o8l _tzy4idpf"])
  }), children);
};